const data = {
  func: {
    list: [
      {
        icon:
          "https://img12.360buyimg.com/imagetools/jfs/t1/151170/19/6862/1021/5fb32e9aE738bce60/1410bab73e903e4b.png",
        text: "商务合作",
      },
      {
        icon:
          "https://img12.360buyimg.com/imagetools/jfs/t1/149756/21/14670/1068/5fb32e9aE203bdbc3/edf899969d7761e9.png",
        text: "注册成为开发者",
      },
      {
        icon:
          "https://img13.360buyimg.com/imagetools/jfs/t1/125630/32/18706/1806/5fb32e9aEf660d396/bc38069a4fdd4bea.png",
        text: "应用开发上线",
      },
      {
        icon:
          "https://img10.360buyimg.com/imagetools/jfs/t1/133663/28/16342/1198/5fb32e9aE1891d588/b709ada7a44d26b1.png",
        text: "开始采购",
      },
    ],
    bgImageUrl:
      "https://img13.360buyimg.com/imagetools/jfs/t1/142736/37/10704/307807/5f8552a2E3bd5c408/8c5d8798fa87dcb7.png",
  },
  style: {
    isShowSubTitle: "show",
    wrapPadding: { unit: 2, quantity: "px" },
    backColor: "#dddddd",
    titlePosition: ["center"],
  },
  data: {
    event: { trigger: "() => {}", eventData: "{}" },
    getData: {
      data: {
        data: [
          { title: "可视化开发", subtitle: "简化前端工程复杂度" },
          { title: "丰富的物料", subtitle: "物料拼装提高项目开发效率" },
          {
            title: "最佳实践",
            subtitle: "结合丰富的经验沉淀出的项目开发最佳实践",
          },
          {
            title: "自定义物料",
            subtitle: "通过物料开发者工具快速开发构建私有物料体系",
          },
          {
            title: "多模版支持",
            subtitle: "支持React、Vue、Angular等框架模版",
          },
          {
            title: "数据灵活配置",
            subtitle: "Json Schema自定义数据可灵活配置页面展示",
          },
        ],
      },
      filter: "() => {}",
    },
  },
};
export default data;
